import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { QuotingTileData } from 'state/quotes/dashboard/model';

import { ResultPanel, SolveModeLabel, TileLayout } from './components';
import { AutoRefreshProgress } from './components/result/AutoRefreshProgress';
import type { TileContentProps } from './Tile.common';

export const QuotingTile: FC<TileContentProps<QuotingTileData>> = ({ data, header, subHeader, footer }) => {
  const resultPanelColor = data.isTradeable ? 'info' : 'success';
  const { formatMessage } = useIntl();

  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color={resultPanelColor}
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="normal" />}
        price={
          <span className="fw-semibold" data-e2e="quoting-label">
            {formatMessage({ id: 'dashboard.quoting' })}
          </span>
        }
        progressBar={<AutoRefreshProgress color={resultPanelColor} timer={data.pricing} isCountDown={false} />}
      />
    </TileLayout>
  );
};

QuotingTile.displayName = 'QuotingTile';
